import React from 'react';
import I18n from 'i18n-js';
import image from '../public/images/notfound.svg';

import css from './not-found-view.less';

const NotFoundView = () => (
  <div className={css.wrap}>
    <img src={image} alt="" />
    <p>{I18n.t('notfound.errorMessage')}</p>
  </div>
);
export default NotFoundView;
